import React from 'react';
import { useTranslation } from 'react-i18next';
import ContentPageLayout from '../components/ContentPageLayout';

const AGB = () => {
  const { t } = useTranslation();

  return (
    <ContentPageLayout>
      {/* AGB Hauptbereich */}
      <section className="py-6 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-2 xl:max-w-[1800px]">
          
          {/* Überschrift */}
          <h1 className="text-lg sm:text-xl font-semibold text-white bg-gray-900 px-6 py-3 rounded-t-lg">
            Allgemeine Geschäftsbedingungen (AGB) – Jannesmann Baumaschinen
          </h1>

          {/* Textbereich */}
          <div className="bg-gray-50 rounded-b-xl border border-gray-200 border-t-0 p-6 md:p-8">

            {/* Einleitung */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-4">
                <strong>Jannesmann Handels- und Import GbR</strong>
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Stand: 2026<br />
                Geltungsbereich: Deutschland & Europäische Union
              </p>
            </div>

            {/* 1. Anbieter */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                1. Anbieter
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Jannesmann Handels- und Import GbR<br />
                Poststraße 6<br />
                46236 Bottrop<br />
                Deutschland
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mt-4">
                <strong>Vertreten durch die Gesellschafter:</strong><br />
                Yasar Kartal<br />
                Jan Hassel<br />
                Ayten Celik
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mt-4">
                E-Mail: <a href="mailto:info@jannesmann.de" className="text-red-600 hover:underline">info@jannesmann.de</a><br />
                Telefon: +49 2041 9877499
              </p>
            </div>

            {/* §1 Geltungsbereich */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                §1 Geltungsbereich
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (1) Diese Allgemeinen Geschäftsbedingungen gelten für alle Verträge über den Verkauf und die Lieferung von Baumaschinen, Zubehör und Ersatzteilen zwischen der Jannesmann Handels- und Import GbR und ihren Kunden.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (2) Kunden im Sinne dieser AGB sind sowohl Verbraucher (§13 BGB) als auch Unternehmer (§14 BGB).
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                (3) Abweichende Bedingungen des Kunden werden nicht anerkannt, es sei denn, wir stimmen ihrer Geltung ausdrücklich schriftlich zu.
              </p>
            </div>

            {/* §2 Vertragsschluss */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                §2 Vertragsschluss
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (1) Die Darstellung der Produkte auf unserer Website stellt kein rechtlich bindendes Angebot, sondern eine unverbindliche Aufforderung zur Abgabe einer Bestellung dar.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (2) Mit dem Absenden einer Bestellung über unsere Website geben Sie ein verbindliches Kaufangebot ab. Sie erhalten eine automatische Eingangsbestätigung, die noch keine Annahme des Angebots darstellt.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                (3) Der Kaufvertrag kommt zustande, wenn wir Ihre Bestellung durch eine Auftragsbestätigung oder durch Lieferung der Ware annehmen.
              </p>
            </div>

            {/* §3 Preise und Zahlung */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                §3 Preise und Zahlung
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (1) Alle angegebenen Preise sind <strong>Nettopreise</strong> in Euro (EUR) und verstehen sich <strong>zzgl. 19% MwSt.</strong> sowie zzgl. Versandkosten, sofern nicht anders angegeben.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (2) Wir bieten folgende Zahlungsmethoden an: Vorkasse, PayPal, Kreditkarte (Visa, Mastercard), Barzahlung bei Abholung, EC-Karte bei Abholung, Kauf auf Rechnung (nach Prüfung).
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                (3) Der Kaufpreis ist sofort bei Bestellung fällig, bei Kauf auf Rechnung innerhalb von 7 Tagen nach Rechnungsdatum.
              </p>
            </div>

            {/* §4 Lieferung und Versand */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                §4 Lieferung und Versand
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (1) Die Lieferung erfolgt an die vom Kunden angegebene Lieferadresse. Selbstabholung am Standort in Bottrop ist nach Absprache möglich.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (2) Bei sperrigen oder schweren Maschinen erfolgt die Lieferung als <strong>Frachtgut per Spedition</strong>. Die Speditionskosten werden individuell berechnet und vor Vertragsschluss mitgeteilt.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (3) Die Lieferzeit beträgt bei lagernden Artikeln in der Regel 1–5 Werktage innerhalb Deutschlands. Bei Vorbestellungen oder Sonderanfertigungen kann die Lieferzeit bis zu 8 Wochen betragen.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                (4) Die Gefahr des zufälligen Untergangs und der Verschlechterung geht bei Lieferung per Spedition mit Übergabe an das Transportunternehmen auf den Kunden über.
              </p>
            </div>

            {/* §5 Eigentumsvorbehalt */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                §5 Eigentumsvorbehalt
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Die gelieferte Ware bleibt bis zur vollständigen Bezahlung des Kaufpreises unser Eigentum.
              </p>
            </div>

            {/* §6 Gewährleistung */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                §6 Gewährleistung und Garantie
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (1) Für unsere Produkte gelten die gesetzlichen Gewährleistungsrechte. Die Gewährleistungsfrist beträgt für Verbraucher 24 Monate, für Unternehmer 12 Monate ab Lieferung.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (2) Zusätzlich gewähren wir auf alle Neumaschinen eine <strong>12-monatige Jannesmann Qualitätsgarantie</strong> auf Material- und Herstellungsfehler.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                (3) Von der Gewährleistung ausgeschlossen sind Schäden durch unsachgemäße Handhabung, Verschleißteile sowie normale Abnutzung.
              </p>
            </div>

            {/* §7 Haftungsbeschränkung */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                §7 Haftungsbeschränkung
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (1) Wir haften unbeschränkt für Schäden aus der Verletzung von Leben, Körper und Gesundheit sowie bei Vorsatz und grober Fahrlässigkeit.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                (2) Bei leichter Fahrlässigkeit haften wir nur bei Verletzung wesentlicher Vertragspflichten und begrenzt auf den vorhersehbaren, typischen Schaden.
              </p>
            </div>

            {/* §8 Widerrufsrecht */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                §8 Widerrufsrecht für Verbraucher
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (1) Verbraucher haben ein 14-tägiges Widerrufsrecht nach den gesetzlichen Bestimmungen. Einzelheiten entnehmen Sie unserer separaten Widerrufsbelehrung.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                (2) Beachten Sie: <strong>Bei Speditionsware (Frachtgut)</strong> trägt der Verbraucher die Rücksendekosten, da aufgrund von Größe/Gewicht der reguläre Postversand nicht möglich ist.
              </p>
            </div>

            {/* §9 Datenschutz */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                §9 Datenschutz
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Informationen zur Verarbeitung Ihrer personenbezogenen Daten finden Sie in unserer <a href="/datenschutz" className="text-red-600 hover:underline">Datenschutzerklärung</a>.
              </p>
            </div>

            {/* §10 Schlussbestimmungen */}
            <div className="mb-8 pb-8 border-b border-gray-200">
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                §10 Schlussbestimmungen
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (1) Es gilt ausschließlich deutsches Recht unter Ausschluss des UN-Kaufrechts.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed mb-3">
                (2) Gerichtsstand für alle Streitigkeiten ist – sofern zulässig – Bottrop.
              </p>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                (3) Sollten einzelne Bestimmungen unwirksam sein, bleibt die Wirksamkeit der übrigen Bestimmungen unberührt.
              </p>
            </div>

            {/* §11 Online-Streitbeilegung */}
            <div>
              <h2 className="text-base sm:text-lg font-bold text-white bg-red-600 px-4 py-2 rounded-lg inline-block mb-4">
                §11 Online-Streitbeilegung
              </h2>
              <p className="text-sm sm:text-base text-gray-700 leading-relaxed">
                Die EU-Kommission stellt eine Plattform zur Online-Streitbeilegung bereit:<br />
                <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-red-600 hover:underline">
                  https://ec.europa.eu/consumers/odr
                </a>
              </p>
            </div>

          </div>
        </div>
      </section>
    </ContentPageLayout>
  );
};

export default AGB;
